export const replaceDashWithEmptySpace = (str: string) => str.replace(/-/g, ' ')
